import plugin from 'tailwindcss/plugin.js';

const config = {
  content: ['./public/**/*.html', './src/**/*.vue'],
  safelist: [
    // 'bg-jkblue',
  ],

  theme: {
    colors: {
      current: 'currentColor',
      black: { DEFAULT: 'var(--color-black)', total: 'var(--color-black-total)' },

      // add more here (also define the colors in main.scss)
      red: {
        DEFAULT: 'var(--color-red-100)',
        5: 'var(--color-red-5)',
        10: 'var(--color-red-10)',
        80: 'var(--color-red-80)',
        90: 'var(--color-red-90)',
        100: 'var(--color-red-100)',
        110: 'var(--color-red-110)',
        120: 'var(--color-red-120)',
        130: 'var(--color-red-130)',
      },

      yellow: {
        DEFAULT: 'var(--color-yellow-100)',
        300: 'var(--color-yellow-300)',
        100: 'var(--color-yellow-100)',
        10: 'var(--color-yellow-10)',
      },

      primary: 'var(--color-red-100)',
      secondary: {
        DEFAULT: 'var(--color-secondary-1)',
        1: 'var(--secondary-1)',
        2: 'var(--secondary-2)',
        3: 'var(--secondary-3)',
      },

      dark: {
        DEFAULT: 'var(--color-text-dark-100)',
        100: 'var(--color-text-dark-100)',
        110: 'var(--color-text-dark-110)',
      },

      neutral: 'var(--color-text-neutral-100)',
      'element-neutral': {
        DEFAULT: 'var(--color-element-neutral-100)',
        110: 'var(--color-element-neutral-110)',
      },
      'background-light': {
        DEFAULT: 'var(--color-background-light-100)',
        110: 'var(--color-background-light-110)',
      },
      'element-white': 'var(--color-element-white-100)',
      'table-head-gray': 'var(--color-table-head-gray-100)',
      'table-text-gray': 'var(--color-table-text-gray-100)',
      'tab-item-gray': 'var(--color-tab-item-gray-100)',
      'checkbox-gray': 'var(--color-checkbox-gray-100)',
      'light-gray': 'var(--color-light-gray-100)',
      'success-green': {
        DEFAULT: 'var(--color-success-green-100)',
        100: 'var(--color-success-green-100)',
        20: 'var(--color-success-green-20)',
        10: 'var(--color-success-green-10)',
      },
      'info-blue': {
        DEFAULT: 'var(--color-info-blue-100)',
        100: 'var(--color-info-blue-100)',
        10: 'var(--color-info-blue-10)',
      },

      selected: 'var(--color-selected)',
      inactive: 'var(--color-inactive)',
      'header-text': 'var(--color-header-text)',
      'body-text': 'var(--color-body-text)',
      'accentuate-text': 'var(--color-accentuate-text)',
      'input-divider': 'var(--color-input-divider)',
      background: 'var(--color-background)',
      white: 'var(--color-white)',
      'table-head': 'var(--color-table-head)',
      'table-text': 'var(--color-table-text)',
      'tab-item': 'var(--color-tab-item)',
      active: 'var(--color-active)',
    },

    extend: {
      fontFamily: {
        sans: ['Inter', 'Source Sans Pro', 'Arial', 'sans-serif'],
      },
      zIndex: {
        toolbar: 100,
        image: 500000,
      },
      borderRadius: {
        4: '4px',
        8: '8px',
      },
      spacing: {
        9.5: '2.375rem',
      },
      width: {
        4.5: '1.125rem',
        5.5: '1.375rem',
        7.5: '1.875rem',
        13: '3.25rem',
        50: '12.5rem',
        'card-content': 'var(--card-content-width)',
        200: '50rem',
      },
      height: {
        4.5: '1.125rem',
        5.5: '1.375rem',
        7.5: '1.875rem',
        13: '3.25rem',
        15: '3.75rem',
        50: '12.5rem',
      },
      gap: {
        4.5: '1.125rem',
        5.5: '1.375rem',
        6.5: '1.625rem',
        7.5: '1.875rem',
        8.5: '2.125rem',
        9.5: '2.375rem',
        10.5: '2.625rem',
        12.5: '3.125rem',
        13: '3.25rem',
        15: '3.75rem',
      },
      padding: {
        card: 'var(--card-padding)',
        4.5: '1.125rem',
        5.5: '1.375rem',
        6.5: '1.625rem',
        7.5: '1.875rem',
        8.5: '2.125rem',
        9.5: '2.375rem',
        10.5: '2.625rem',
        12.5: '3.125rem',
        13: '3.25rem',
        15: '3.75rem',
        17.5: '4.375rem',
        18.5: '4.625rem',
        22.5: '5.625rem',
        25: '6.25rem',
      },
      margin: {
        5.5: '1.375rem',
        6.5: '1.625rem',
        7.5: '1.875rem',
        8.5: '2.125rem',
        9.5: '2.375rem',
        10.5: '2.625rem',
        12.5: '3.125rem',
        15: '3.75rem',
        17.5: '4.375rem',
        25: '6.25rem',
        37.5: '9.375rem',
      },
    },

    screens: {
      sm: '640px',
      md: '920px',
      lg: '1500px',
      xl: '1900px',
    },
  },

  plugins: [
    plugin(({ addUtilities, theme }) => {
      addUtilities({
        'h1, .h1': {
          fontSize: '30px',
          lineHeight: '45px',
          fontWeight: 700,
          color: 'var(--color-text-dark-100)',
        },

        'h2, .h2': {
          fontSize: '24px',
          lineHeight: '30px',
          fontWeight: 400,
          color: 'var(--color-text-dark-100)',
        },

        'h3, .h3': {
          fontSize: '20px',
          lineHeight: '20px',
          fontWeight: 700,
          textTransform: 'uppercase',
          color: 'var(--color-text-dark-100)',
        },

        '.text-title': {
          fontSize: '38px',
          lineHeight: '57px',
          fontWeight: 700,
          color: 'var(--color-text-dark-100)',
        },

        '.text-body-big': {
          fontSize: '20px',
          lineHeight: '24px',
          fontWeight: 400,
        },

        '.text-body-regular': {
          fontSize: '16px',
          lineHeight: '22px',
        },

        '.text-body-regular-bold': {
          fontSize: '16px',
          lineHeight: '22px',
          fontWeight: 700,
        },

        '.text-input': {
          fontSize: '16px',
          lineHeight: '22px',
          fontWeight: 700,
        },

        '.text-nav': {
          fontSize: '22px',
          lineHeight: '28px',
          fontWeight: 400,
        },

        '.text-tab': {
          fontSize: '20px',
          lineHeight: '24px',
          fontWeight: 400,
          textTransform: 'uppercase',
        },

        '.text-button': {
          fontSize: '18px',
          lineHeight: '18px',
          fontWeight: 700,
        },

        '.text-table-header': {
          fontSize: '18px',
          lineHeight: '24px',
          fontWeight: 700,
          textTransform: 'uppercase',
        },

        '.text-pane-label': {
          fontSize: '12px',
          lineHeight: '16px',
        },

        '.text-pane-label-active': {
          fontSize: '10px',
          lineHeight: '12px',
        },

        '.text-pre': {
          fontSize: '10px',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.03em',
        },

        '.text-pre-title-big': {
          fontSize: '14px',
          fontWeight: 700,
          lineHeight: '24px',
          textTransform: 'uppercase',
        },

        '.text-menu': {
          fontSize: '16px',
          lineHeight: '22px',
          fontWeight: 400,
        },

        '.appearance-clean': {
          appearance: 'none',
          '-moz-appearance': 'textfield',
          '&::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
          },
          '&::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
          },
        },
      });
    }),
  ],
};

export default config;
export const {
  content,
  theme,
  safelist,
  plugins,
} = config;
